document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.getElementById('ProductMainImage');
  thumbs.forEach(function (thumb, index) {
    if (index === 0) thumb.classList.add('is-active');
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-image-src');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var heroThumbs = document.querySelectorAll('.hero-thumb');
  var heroMainImage = document.getElementById('HeroMainImage');
  heroThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (heroMainImage) heroMainImage.src = thumb.getAttribute('data-image-src');
      heroThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var heroThumbsMore = document.getElementById('HeroThumbsMore');
  var heroThumbsContainer = document.getElementById('HeroThumbs');
  if (heroThumbsMore && heroThumbsContainer) {
    heroThumbsMore.addEventListener('click', function () {
      heroThumbsContainer.classList.toggle('is-expanded');
    });
  }

  initBundleBuilder();
  applyPackFromQuery();
  initCountdownTimers();
  initSmoothAnchorScroll();
  initStickyBar();
  initSocialProofToast();
});

function applyPackFromQuery() {
  var params = new URLSearchParams(window.location.search);
  var pack = params.get('pack');
  if (!pack) return;
  var target = document.querySelector('[data-set-quantity="' + pack + '"]');
  if (target) target.click();
}

function initSmoothAnchorScroll() {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (history.pushState) history.pushState(null, '', '#' + id);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

function initCountdownTimers() {
  var timers = document.querySelectorAll('[data-countdown]');
  timers.forEach(function (el) {
    var minutes = parseInt(el.getAttribute('data-countdown-minutes'), 10) || 120;
    var cycleMs = minutes * 60 * 1000;
    var timeEl = el.querySelector('[data-countdown-time]');
    if (!timeEl) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      var remaining = cycleMs - (Date.now() % cycleMs);
      var totalSeconds = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;
      timeEl.textContent = pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initStickyBar() {
  var bar = document.getElementById('StickyCtaBar');
  var offerCard = document.querySelector('.offer-card');
  var stickyBtn = document.getElementById('StickyCtaButton');
  var addButton = document.getElementById('AddBundleToCart');
  if (!bar || !offerCard) return;

  function checkVisibility() {
    var rect = offerCard.getBoundingClientRect();
    var pastOffer = rect.bottom < 0;
    bar.classList.toggle('is-visible', pastOffer);
  }

  window.addEventListener('scroll', checkVisibility, { passive: true });
  checkVisibility();

  if (stickyBtn && addButton) {
    stickyBtn.addEventListener('click', function () {
      addButton.click();
    });
  }
}

function initSocialProofToast() {
  var dataEl = document.getElementById('SocialProofData');
  var toast = document.getElementById('SocialProofToast');
  if (!dataEl || !toast) return;

  var items;
  try {
    items = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  items = items.filter(function (item) { return item && item.name && item.purchasedAt; });
  if (!items.length) return;

  var avatarEl = document.getElementById('SocialProofAvatar');
  var textEl = document.getElementById('SocialProofText');
  var timeEl = document.getElementById('SocialProofTime');
  var closeBtn = document.getElementById('SocialProofClose');

  var index = 0;
  var dismissed = false;
  var visibleMs = 6000;
  var gapMs = 9000;

  function timeAgo(iso) {
    var then = new Date(iso).getTime();
    if (isNaN(then)) return '';
    var diffMs = Date.now() - then;
    if (diffMs < 0) return 'hace un momento';
    var mins = Math.floor(diffMs / 60000);
    if (mins < 60) return 'hace ' + Math.max(mins, 1) + ' min';
    var hours = Math.floor(mins / 60);
    if (hours < 24) return 'hace ' + hours + ' h';
    var days = Math.floor(hours / 24);
    return 'hace ' + days + ' día' + (days === 1 ? '' : 's');
  }

  function showNext() {
    if (dismissed || index >= items.length) return;
    var item = items[index];
    index++;
    if (avatarEl) avatarEl.textContent = item.name.charAt(0).toUpperCase();
    if (textEl) {
      var location = item.city ? ' (' + item.city + ')' : '';
      textEl.textContent = item.name + location + ' compró ' + (item.product || 'un pack Serena');
    }
    if (timeEl) timeEl.textContent = timeAgo(item.purchasedAt);
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(hideToast, visibleMs);
  }

  function hideToast() {
    toast.classList.remove('is-visible');
    setTimeout(function () {
      toast.hidden = true;
      if (!dismissed && index < items.length) setTimeout(showNext, gapMs);
    }, 400);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      hideToast();
    });
  }

  setTimeout(showNext, 4000);
}

function syncReleasitVariant(color, size) {
  if (!color || !size) return;
  var synced = new WeakSet();
  var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set;

  function applySync() {
    document.querySelectorAll('select.rsi-variant-picker-select').forEach(function (sel) {
      if (synced.has(sel)) return;
      var match = Array.prototype.find.call(sel.options, function (opt) {
        return opt.textContent.trim().indexOf(color + ' / ' + size) === 0;
      });
      if (match && sel.value !== match.value) {
        nativeSetter.call(sel, match.value);
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      synced.add(sel);
    });
  }

  applySync();
  var observer = new MutationObserver(applySync);
  observer.observe(document.body, { childList: true, subtree: true });
}

function initBundleBuilder() {
  var optionsDataEl = document.getElementById('ProductOptionsData');
  var variantsDataEl = document.getElementById('ProductVariantsData');
  var addButton = document.getElementById('AddBundleToCart');
  var errorEl = document.getElementById('BundleError');
  var colorGrid = document.getElementById('ColorPackGrid');
  var sizeRow = document.getElementById('SizeBtnRow');
  if (!optionsDataEl || !variantsDataEl || !addButton || !colorGrid || !sizeRow) return;

  var options = JSON.parse(optionsDataEl.textContent); // [{name, position, values}, ...]
  var variants = JSON.parse(variantsDataEl.textContent); // [{id, option1, option2, ..., available}, ...]
  var colorIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'color'; });
  var sizeIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'size'; });
  var packIndex = options.findIndex(function (o) { return o.name.toLowerCase() === 'pack'; });
  var qtyToPack = { 2: 'x2', 4: 'x4', 7: 'x7' };

  function findVariant(color, size, qty) {
    var packValue = packIndex !== -1 ? qtyToPack[qty] : null;
    return variants.find(function (v) {
      var matchesColor = colorIndex === -1 || v['option' + (colorIndex + 1)] === color;
      var matchesSize = sizeIndex === -1 || v['option' + (sizeIndex + 1)] === size;
      var matchesPack = packIndex === -1 || v['option' + (packIndex + 1)] === packValue;
      return matchesColor && matchesSize && matchesPack;
    });
  }

  var state = {
    qty: 2,
    mode: 'simple',
    color: colorGrid.querySelector('.color-pack-swatch:not(.color-pack-custom)').getAttribute('data-color'),
    size: sizeRow.querySelector('.size-btn').getAttribute('data-size'),
    customCounts: {},
    customSizes: {}
  };

  var packLabelEl = document.getElementById('PackSummaryLabel');
  var packQtyEl = document.getElementById('PackSummaryQty');
  var sizeLabelEl = document.getElementById('SizeSummaryLabel');

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.hidden = true;
  }

  function updatePackSummary() {
    if (packQtyEl) packQtyEl.textContent = '(x' + state.qty + ')';
    if (!packLabelEl) return;
    if (state.mode === 'custom') {
      packLabelEl.textContent = 'Personalizado';
    } else {
      packLabelEl.textContent = state.color;
    }
  }

  function updateSizeSummary() {
    if (sizeLabelEl) sizeLabelEl.textContent = state.size;
    var badge = document.getElementById('MiPackSizeBadge');
    if (badge) badge.textContent = state.size;
  }

  colorGrid.querySelectorAll('.color-pack-swatch:not(.color-pack-custom)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.color = btn.getAttribute('data-color');
      state.mode = 'simple';
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      updatePackSummary();
      hideError();
    });
  });

  sizeRow.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.size = btn.getAttribute('data-size');
      sizeRow.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      updateSizeSummary();
      hideError();
    });
  });

  // ---- MiPack custom builder ----
  var modal = document.getElementById('MiPackModal');
  var openBtn = document.getElementById('OpenMiPack');
  var closeBtn = document.getElementById('MiPackClose');
  var confirmBtn = document.getElementById('MiPackConfirm');
  var countLabel = document.getElementById('MiPackCountLabel');
  var progressFill = document.getElementById('MiPackProgressFill');
  var selectedList = document.getElementById('MiPackSelectedList');
  var colorCards = modal ? modal.querySelectorAll('.mipack-color-card') : [];

  function miPackTotal() {
    return Object.keys(state.customCounts).reduce(function (sum, key) { return sum + state.customCounts[key]; }, 0);
  }

  function renderMiPack() {
    var total = miPackTotal();
    if (countLabel) countLabel.textContent = 'Número de artículos: ' + total + ' / ' + state.qty;
    if (progressFill) progressFill.style.width = Math.min(100, (total / state.qty) * 100) + '%';
    if (confirmBtn) confirmBtn.disabled = total !== state.qty;

    colorCards.forEach(function (card) {
      var color = card.getAttribute('data-color');
      var count = state.customCounts[color] || 0;
      var countEl = card.querySelector('.mipack-color-count');
      if (countEl) {
        countEl.textContent = count;
        countEl.hidden = count === 0;
      }
    });

    if (selectedList) {
      selectedList.innerHTML = '';
      Object.keys(state.customCounts).forEach(function (color) {
        var count = state.customCounts[color];
        if (count <= 0) return;
        var item = document.createElement('div');
        item.className = 'mipack-selected-item';
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'mipack-remove-btn';
        removeBtn.setAttribute('data-color', color);
        removeBtn.textContent = '−';
        var label = document.createElement('span');
        var itemSize = state.customSizes[color] || state.size;
        label.textContent = count + ' × ' + color + ' (' + itemSize + ')';
        item.appendChild(removeBtn);
        item.appendChild(label);
        selectedList.appendChild(item);
      });
      selectedList.querySelectorAll('.mipack-remove-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var color = btn.getAttribute('data-color');
          state.customCounts[color] = Math.max(0, (state.customCounts[color] || 0) - 1);
          renderMiPack();
        });
      });
    }
  }

  if (openBtn && modal) {
    openBtn.addEventListener('click', function () {
      state.customCounts = {};
      state.customSizes = {};
      modal.querySelectorAll('.mipack-color-size').forEach(function (select) {
        select.value = state.size;
      });
      updateSizeSummary();
      renderMiPack();
      modal.hidden = false;
    });
  }
  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function () {
      modal.hidden = true;
    });
  }
  colorCards.forEach(function (card) {
    var addTarget = card.querySelector('[data-action="add"]');
    var sizeSelect = card.querySelector('.mipack-color-size');
    if (!addTarget) return;
    addTarget.addEventListener('click', function () {
      var color = card.getAttribute('data-color');
      if (miPackTotal() >= state.qty) return;
      if (sizeSelect) state.customSizes[color] = sizeSelect.value;
      state.customCounts[color] = (state.customCounts[color] || 0) + 1;
      renderMiPack();
    });
  });
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (miPackTotal() !== state.qty) return;
      state.mode = 'custom';
      updatePackSummary();
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      modal.hidden = true;
      addToCartAndCheckout();
    });
  }

  // ---- Cart + checkout ----
  function addToCartAndCheckout() {
    var items = [];

    if (state.mode === 'custom') {
      var colors = Object.keys(state.customCounts).filter(function (c) { return state.customCounts[c] > 0; });
      for (var i = 0; i < colors.length; i++) {
        var itemSize = state.customSizes[colors[i]] || state.size;
        var variant = findVariant(colors[i], itemSize, state.qty);
        if (!variant || !variant.available) {
          showError('La combinación ' + colors[i] + ' / ' + itemSize + ' no está disponible. Prueba con otra talla.');
          return;
        }
        items.push({ id: variant.id, quantity: state.customCounts[colors[i]] });
      }
    } else {
      var singleVariant = findVariant(state.color, state.size, state.qty);
      if (!singleVariant || !singleVariant.available) {
        showError('La combinación ' + state.color + ' / ' + state.size + ' no está disponible. Prueba con otro color o talla.');
        return;
      }
      items.push({ id: singleVariant.id, quantity: state.qty });
    }

    hideError();
    addButton.disabled = true;
    addButton.textContent = 'Procesando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.textContent = 'Comprar ahora';
        showError('No pudimos agregar tu paquete al carrito. Intenta de nuevo.');
      });
  }

  addButton.addEventListener('click', function () {
    var releasitButton = document.getElementById('rsi_buy_now_button');
    if (releasitButton) {
      releasitButton.click();
      if (state.mode === 'simple') syncReleasitVariant(state.color, state.size);
      return;
    }
    addToCartAndCheckout();
  });

  // ---- Pack quantity shortcuts ----
  var totalPriceEl = document.getElementById('PackTotalPrice');
  var stickyPriceEl = document.getElementById('StickyCtaPrice');
  var topPriceEl = document.getElementById('ProductUnitPrice');
  var topPriceLabelEl = document.getElementById('ProductPriceLabel');
  var updateTotal = function (btn) {
    if (!btn) return;
    var total = btn.getAttribute('data-total-price');
    if (!total) return;
    var formatted = Number(total).toLocaleString('es-CO');
    if (totalPriceEl) totalPriceEl.innerHTML = '$' + formatted + ' <small>COP</small>';
    if (stickyPriceEl) stickyPriceEl.innerHTML = '$' + formatted + ' <small>COP</small>';
  };
  var updateUnitPrice = function (btn) {
    if (!topPriceEl || !btn) return;
    var total = btn.getAttribute('data-total-price');
    if (!total) return;
    topPriceEl.textContent = '$ ' + Number(total).toLocaleString('es-CO');
    if (topPriceLabelEl) topPriceLabelEl.textContent = 'por paquete';
  };

  var shortcuts = document.querySelectorAll('[data-set-quantity]');
  var markActive = function (value) {
    shortcuts.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-set-quantity') === String(value));
    });
  };
  shortcuts.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var qty = parseInt(btn.getAttribute('data-set-quantity'), 10);
      state.qty = qty;
      state.mode = 'simple';
      state.customCounts = {};
      colorGrid.querySelectorAll('.color-pack-swatch').forEach(function (b, idx) { b.classList.toggle('is-active', idx === 0); });
      if (colorIndex !== -1) state.color = colorGrid.querySelector('.color-pack-swatch:not(.color-pack-custom)').getAttribute('data-color');
      markActive(qty);
      updatePackSummary();
      updateTotal(btn);
      updateUnitPrice(btn);
      hideError();
    });
  });

  var firstShortcut = shortcuts[0];
  var initialQty = firstShortcut ? parseInt(firstShortcut.getAttribute('data-set-quantity'), 10) : 2;
  state.qty = initialQty;
  markActive(initialQty);
  updatePackSummary();
  updateSizeSummary();
  updateTotal(firstShortcut);
  updateUnitPrice(firstShortcut);
}